import React, {useEffect, useState} from 'react';
import {useNavigate, useParams} from "react-router-dom";
import {Button} from "primereact/button";
import {UuserService} from "../../service/UuserService";
import { Divider } from 'primereact/divider';
import { Tag } from 'primereact/tag';
import GeneralUtils from "../../utils/GeneralUtils";


const InstructorInfo =(props)=> {
    const [data, setData] = useState(!GeneralUtils.isNullOrEmpty(props) ? props.data : {});

    const {instructorId} = useParams();

    const navigate = useNavigate();

    const service = new UuserService();


    useEffect(() => {
        // service.checkPage();
        if(!GeneralUtils.isNullOrEmpty(instructorId)){
            service.findById(instructorId).then(response => setData(response));
        }
    }, []);

    return (
        <div className="flex justify-content-around" style={{marginTop: "20px"}}>
            <div className="flex flex-column gap-3 w-30rem" >
                <div><Tag value="EĞİTMEN"/></div>

                <h3>{data.displayName}</h3>
                <h4>{data.jobTitle}</h4>

                <Divider align="left">
                    <div className="inline-flex align-items-center">
                        <i className="pi pi-user mr-2"></i>
                        <p><b>Hakkımda</b></p>
                    </div>
                </Divider>
                <div dangerouslySetInnerHTML={{__html: data.description}}/>


            </div>
            <div className="flex flex-column gap-3">
                <div className="team-details-thumb">
                    <div className="thumbnail">
                        {data.image200h ?
                            <img src={data.image200h} alt="Image" width="200" className="instructor-image"/>
                            : <img src='/assets/images/placeholder.png' alt="Image" width="200" className="instructor-image"/>}
                    </div>
                </div>
                {data.urlPersonalWebSite &&
                    <Button label="Web Sitesi" style={{width: "100%"}} size="small"
                            onClick={() => navigate(data.urlPersonalWebSite)}/>}
            </div>

        </div>
    );
}

export default InstructorInfo;